import zhTWLocale from "element-ui/lib/locale/lang/zh-TW";

const cntw = {
  // 单词类
  "登录":"登錄",
  "公司":"公司",
  "主页":"主頁",
  "设定":"設定",
  "退出":"登出",
  "努力加载中":"努力加載中",
  "全部":"全部",
  "":"",

  // element多语言
  ...zhTWLocale
}

export default cntw
